module.exports = __webpack_public_path__ + "static/img/NO@3x.b9a14127.jpg";